import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-dropdown-menu',
    templateUrl: './wdx-dropdown-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxDropdownMenuComponent {}
